// Stellarium Web - Copyright (c) 2018 - Noctua Software Ltd
//
// This program is licensed under the terms of the GNU AGPL v3, or
// alternatively under a commercial licence.
//
// The terms of the AGPL v3 license can be found in the main directory of this
// repository.

<template>
  <div style="display: flex; flex-direction: row; width: 100%;">
    <!-- <div v-if="$store.state.showTimeButtons" class="dp-container"
      @click="() => $store.commit('setShowTimeButtons', false)" /> 遮蔽层-->
    <div v-if="$store.state.showTimeButtons" class="dtpn-time-box">
      
      <div class="dtpn-time-box-left">     
        <v-row justify="space-between" no-gutters class="ma-3">
          <div class="bbn-column">
            <div class="up_down_bt" @click="incTime('years')">
              <v-icon>mdi-menu-up</v-icon>
            </div>
            <div>{{ year }}</div>
            <div class="up_down_bt" @click="decTime('years')">
              <v-icon>mdi-menu-down</v-icon>
            </div>
          </div>
          <div class="bbn-column bbn-column-text">-</div>
          <div class="bbn-column">
            <div class="up_down_bt" @click="incTime('months')">
              <v-icon>mdi-menu-up</v-icon>
            </div>
            <div>{{ month }}</div>
            <div class="up_down_bt" @click="decTime('months')">
              <v-icon>mdi-menu-down</v-icon>
            </div>
          </div>
          <div class="bbn-column bbn-column-text">-</div>
          <div class="bbn-column">
            <div class="up_down_bt" @click="incTime('days')">
              <v-icon>mdi-menu-up</v-icon>
            </div>
            <div>{{ day }}</div>
            <div class="up_down_bt" @click="decTime('days')">
              <v-icon>mdi-menu-down</v-icon>
            </div>
          </div>
          <div class="bbn-column-center" />
          <div class="bbn-column">
            <div class="up_down_bt" @click="incTime('hours')">
              <v-icon>mdi-menu-up</v-icon>
            </div>
            <div>{{ hour }}</div>
            <div class="up_down_bt" @click="decTime('hours')">
              <v-icon>mdi-menu-down</v-icon>
            </div>
          </div>
          <div class="bbn-column bbn-column-text">:</div>
          <div class="bbn-column">
            <div class="up_down_bt" @click="incTime('minutes')">
              <v-icon>mdi-menu-up</v-icon>
            </div>
            <div>{{ minute }}</div>
            <div class="up_down_bt" @click="decTime('minutes')">
              <v-icon>mdi-menu-down</v-icon>
            </div>
          </div>
          <div class="bbn-column bbn-column-text">:</div>
          <div class="bbn-column">
            <div class="up_down_bt" @click="incTime('seconds')">
              <v-icon>mdi-menu-up</v-icon>
            </div>
            <div>{{ second }}</div>
            <div class="up_down_bt" @click="decTime('seconds')">
              <v-icon>mdi-menu-down</v-icon>
            </div>
          </div>
        </v-row>
      </div>
      <div class="dtpn-time-box-right">
        <div class="dtpn-time-box-right-item" @click="resetTime">
          <img class="bbn-time-image" src="../assets/icon/back-time.png">
        </div>
        <div class="dtpn-time-box-right-item"  >
          <v-btn style="font-weight: 900;" v-if="this.$stel.core.time_speed == 0.5" text  @click="setTimeSpeed(1)" >0.5x</v-btn>
          <v-btn style="font-weight: 900;" v-else-if="this.$stel.core.time_speed == 1"   text  @click="setTimeSpeed(2)" >1.0x</v-btn>
          <v-btn style="font-weight: 900;" v-else-if="this.$stel.core.time_speed == 2"   text  @click="setTimeSpeed(8)" >2.0x</v-btn>
          <v-btn style="font-weight: 900;" v-else-if="this.$stel.core.time_speed == 8"   text  @click="setTimeSpeed(32)" >8.0x</v-btn>
          <v-btn style="font-weight: 900;" v-else-if="this.$stel.core.time_speed == 32"  text  @click="setTimeSpeed(0.5)" >32.0x</v-btn>
      </div>
        <div class="dtpn-time-box-right-item" @click="togglePauseTime">
          <img v-if="togglePauseTimeIcon == 'mdi-pause'" class="bbn-time-image" src="../assets/icon/pause-time.png">
          <img v-if="togglePauseTimeIcon == 'mdi-play'" class="bbn-time-image" src="../assets/icon/start-time.png">
        </div>
      </div>
      
    </div>
    <v-slider min="0" max="1439" trackFillColor="#3A5AC2" trackColor="rgba(107, 122, 153, 0.7)" thumbColor="#3A5AC2"
      v-model="timeMinute"></v-slider>
  </div>
</template>

<script>

import Moment from 'moment'
import throttle from 'lodash.throttle'

var clickTimeout
var nbClickRepeat = 0

export default {
  data: function () {
    return {
      stops: [],
      stopCacheKey: {
        sliderStartTime: undefined,
        location: undefined
      }
    }
  },
  props: ['value', 'location'],
  computed: {
    // The MomentJS time in local time
    localTime: {
      get: function () {
        const m = Moment(this.value)
        m.local()
        return m
      },
      set: function (newValue) {
        this.$emit('input', newValue.format())
      }
    },
    time: {
      get: function () {
        return this.localTime.format('HH:mm:ss')
      }
    },
    date: {
      get: function () {
        return this.localTime.format('YYYY-MM-DD')
      }
    },
    year: {
      get: function () {
        return this.localTime.format('YYYY')
      }
    },
    month: {
      get: function () {
        return this.localTime.format('MM')
      }
    },
    day: {
      get: function () {
        return this.localTime.format('DD')
      }
    },
    hour: {
      get: function () {
        return this.localTime.format('HH')
      }
    },
    minute: {
      get: function () {
        return this.localTime.format('mm')
      }
    },
    second: {
      get: function () {
        return this.localTime.format('ss')
      }
    },
    timeMinute: {
      get: function () {
        // 0 means 12:00, 720 means midnight, 1440 (=24*60) means 12:00 the day after
        const t = this.localTime
        return t.hours() < 12 ? (t.hours() + 12) * 60 + t.minutes() : (t.hours() - 12) * 60 + t.minutes()
      },
      set: function (newValue) {
        var t = Moment(this.sliderStartTime)
        t.add(newValue, 'minutes')
        this.$emit('input', t.format())
      }
    },
    sliderStartTime: function () {
      const t = this.localTime.clone()
      if (t.hours() < 12) {
        t.subtract(1, 'days')
      }
      t.hours(12)
      t.minutes(0)
      t.seconds(0)
      t.milliseconds(0)
      return t
    },
    sliderHint: function () {
      const tm = this.timeMinute
      const stop = this.stops[Math.floor(tm * this.stops.length / 1440)]
      if (!stop) return ''
      if (stop.sunAlt > 0) {
        return this.$t('Daylight')
      }
      if (stop.sunAlt < -16) {
        return stop.moonAlt < 5 ? this.$t('Dark night') : this.$t('Moonlight')
      }
      return tm > 720 ? this.$t('Dawn') : this.$t('Twilight')
    },
    isTimePaused: function () {
      return this.$store.state.timeSpeed === 0
    },
    togglePauseTimeIcon: function () {
      return this.isTimePaused ? 'mdi-play' : 'mdi-pause'
    }
  },
  methods: {
    resetTime: function () {
      const m = Moment()
      m.local()
      this.$emit('input', m.format())
    },
    togglePauseTime: function () {
      this.$stel.core.time_speed = (this.$stel.core.time_speed === 0) ? 1 : 0
      // console.log(this.togglePauseTimeIcon)
      this.$store.commit('setValue', { varName: 'timeSpeed', newValue: this.isTimePaused ? 1 : 0 })
    },
    setTimeSpeed:function(speed){
      this.$stel.core.time_speed = speed
      this.$store.commit('setValue', { varName: 'timeSpeed', newValue: speed })
    },
    incTime: throttle(function (unit) {
      this.startIncTime(1, unit)
    }, 50),
    decTime: throttle(function (unit) {
      this.startIncTime(-1, unit)
    }, 50),
    startIncTime: function (v, unit) {
      const that = this
      clickTimeout = setTimeout(_ => {
        const t = this.localTime.clone()
        t.add(v, unit)
        this.$emit('input', t.format())
        nbClickRepeat++
        that.startIncTime(v, unit)
        that.stopIncTime()
      }, nbClickRepeat === 0 ? 0 : (nbClickRepeat === 1 ? 500 : (nbClickRepeat < 10 ? 100 : (nbClickRepeat < 100 ? 50 : 20))))
    },
    stopIncTime: function () {
      if (clickTimeout) {
        clearTimeout(clickTimeout)
        clickTimeout = undefined
        nbClickRepeat = 0
      }
    },
    // 0 means 12:00, 720 means midnight, 1440 (=24*60) means 12:00 the day after
    timeMinuteRangeToUTC: function (tm) {
      return this.sliderStartTime.toDate().getMJD() + tm * 1 / (24 * 60)
    },
    refreshStops: function () {
      if (this.stopCacheKey.sliderStartTime === this.sliderStartTime.format() && this.stopCacheKey.location === JSON.stringify(this.location)) {
        return
      }
      const res = []
      const nbStop = 49
      const obs = this.$stel.core.observer.clone()
      const sun = this.$stel.getObj('NAME Sun')
      const moon = this.$stel.getObj('NAME Moon')
      for (let i = 0; i <= nbStop; ++i) {
        obs.utc = this.timeMinuteRangeToUTC(1440 * i / nbStop)
        const sunAlt = this.$stel.anpm(this.$stel.c2s(this.$stel.convertFrame(obs, 'ICRF', 'OBSERVED', sun.getInfo('radec', obs)))[1]) * 180.0 / Math.PI
        const moonAlt = this.$stel.anpm(this.$stel.c2s(this.$stel.convertFrame(obs, 'ICRF', 'OBSERVED', moon.getInfo('radec', obs)))[1]) * 180.0 / Math.PI
        const brightnessForAltitude = function (sunAlt, moonAlt) {
          const moonBrightness = moonAlt < 0 ? 0 : 2 / 35 * Math.min(20, moonAlt) / 20
          if (sunAlt > 0) return Math.min(10, 1 + sunAlt) + moonBrightness
          if (sunAlt < -16) return moonBrightness
          if (sunAlt < -10) return 1 / 35 * (16 + sunAlt) / 6 + moonBrightness
          return (1 - 1 / 35) * (10 + sunAlt) / 10 + 1 / 35 + moonBrightness
        }
        const brightness = Math.log10(1 + brightnessForAltitude(sunAlt, moonAlt) * 10) / 2
        res.push({
          percent: i / nbStop,
          style: 'stop-color:rgb(64,209,255);stop-opacity:' + brightness,
          sunAlt: sunAlt,
          moonAlt: moonAlt
        })
      }
      obs.destroy()
      this.stopCacheKey.sliderStartTime = this.sliderStartTime.format()
      this.stopCacheKey.location = JSON.stringify(this.location)
      this.stops = res
    }
  },
  mounted: function () {
    this.refreshStops()
    const that = this
    window.addEventListener('mouseup', function (event) {
      that.stopIncTime()
    })
  },
  watch: {
    sliderStartTime: function () {
      this.refreshStops()
    },
    location: function () {
      this.refreshStops()
    }
  }
}
</script>

<style>
.dp-container {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}

.dtpn-time-box {
  position: absolute;
  display: flex;
  flex-direction: row;
  right: 10px;
  bottom: 100px;
  background: rgba(46, 55, 77, 0.8);
  color: rgba(255, 255, 255, 0.8);
  height: 160px;
  border-radius: 10px;
  overflow: hidden;
}

.dtpn-time-box-left {
  display: flex;
  flex: 1;
}

.dtpn-time-box-right {
  display: flex;
  flex-direction: column;
  width: 60px;
  background: rgba(37, 45, 65, 0.8);
}

.dtpn-time-box-right-item {
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
}

.dtpn-time-box-right-item:active img {
  opacity: 0.5;
}

.up_down_bt {
  display: flex;
  flex: 1;
}

.up_down_bt:hover i {
  color: deepskyblue;
}

.up_down_bt:hover i:before {
  border-radius: 100%;
  background: rgba(255, 255, 255, 0.1);
}

.up_down_bt:active i {
  color: deepskyblue;
  opacity: 0.5;
}

.up_down_bt:active i:before {
  border-radius: 100%;
  background: rgba(255, 255, 255, 0);
}

.bbn-time-image {
  width: 25px;
  height: 25px;
}

.bbn-column {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 34px;
  font-weight: bold;
}

.bbn-column-text {
  padding-bottom: 5px;
}

.bbn-column-center {
  margin: 0 8px;
}

@media screen and (max-width: 600px) {
  .dtpn-time-box {
    position: absolute;
    display: flex;
    flex-direction: row;
    right: 10px;
    bottom: 95px;
    background: rgba(46, 55, 77, 0.8);
    height: 160px;
    border-radius: 10px;
    overflow: hidden;
  }

  .bbn-column {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 30px;
    font-weight: bold;
  }

  .bbn-column-text {
    padding-bottom: 5px;
  }

  .bbn-column-center {
    margin: 0 5px;
  }
}

@media screen and (max-width: 450px) {
  .dtpn-time-box {
    position: absolute;
    display: flex;
    flex-direction: row;
    left: 10px;
    right: 10px;
    bottom: 95px;
    background: rgba(46, 55, 77, 0.8);
    height: 36vw;
    min-height: 120px; 
    border-radius: 10px;
    overflow: hidden;
  }

  .dtpn-time-box-right {
    display: flex;
    flex-direction: column;
    width: 15vw;
    min-width: 40px; 
    background: rgba(37, 45, 65, 0.8);
  }

  .bbn-time-image {
    width: 6vw;
    height: 6vw;
    min-width: 20px; 
    min-height: 20px; 
  }

  .bbn-column {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 7vw;
    min-font-size: 16px; 
    font-weight: bold;
  }

  .bbn-column-text {
    padding-bottom: 2px; 
  }

  .bbn-column-center {
    margin: 0 2px; 
  }
  
  
  .up_down_bt {
    padding: 2px;
  }
  
  .v-icon {
    font-size: 16px !important;
  }
}

@media screen and (max-width: 320px) {
  .dtpn-time-box {
    height: auto;
    padding: 5px;
  }
  
  .bbn-column {
    font-size: 14px;
  }
  
  .v-icon {
    font-size: 14px !important;
  }
  
  .dtpn-time-box-right {
    width: 40px;
  }
}
</style>